//******************************************************************************
// クリックした頂点の座標と色を取得する関数（点群専用）
// 共通利用を可能にするためモジュール化
//******************************************************************************
// import
import MapLibreGL from "maplibre-gl";

//******************************************************************************
// export function
/**
 * @param {object} picking ピッキング対象
 * @returns {Object} picked ピッキング対象の座標と色
 * @property {[number, number, number]} picked.coordinates 経度、緯度、標高
 * @property {Uint8Array|Uint8ClampedArray} picked.color RGBA
*/
export const getPickedVertex = (picking) => {



	/**
	 * 取り出したattributesがundefinedになる時があるらしいから分岐が必要
	 */






	// 頂点データを取り出す
	// const attributes = picking.layer.props.data.attributes;
	const attributes = picking.layer?.props?.data?.attributes;
	// PointCloudLayerインスタンス生成時に組み込んだ点群PNGパラメータを取得
	// const pcpng = picking.layer.props.pcpngData.pcpng;
	const pcpng = picking.layer?.props?.pcpngData?.pcpng;
	// タイミング上取得できない場合もあるのでその場合はnullを返す
	if (
		typeof attributes === "undefined"
		|| typeof pcpng === "undefined"
	) {
		return null;
	}


	// 頂点データを格納するためのオブジェクトを用意
	const vertex = {};
	// 頂点を走査
	Object.keys(attributes).forEach((key) => {
		//該当頂点を取り出す
		const attribute = attributes[key];
		const value = attribute.buffer.props.data.slice(
			attribute.size * picking.index,
			attribute.size * (picking.index + 1)
		);
		// 得られた頂点をキーを使ってオブジェクトに格納する
		vertex[key] = value;
	});
	// PointCloudLayerインスタンス生成時のエンコードと逆の手順でポイント座標を求める
	const worldSize = 2 ** pcpng.webmercatorDegree;
	const pointXY = new MapLibreGL.MercatorCoordinate(
		(pcpng.offset.x + vertex.getPosition[0] / pcpng.meterPerPixel.x) / worldSize,
		(pcpng.offset.y - vertex.getPosition[1] / pcpng.meterPerPixel.y) / worldSize,
	);
	// 経緯度に変換
	const lnglat = pointXY.toLngLat();
	// 標高値はそのままオフセットを加算（ただしオフセットは多分0）
	const elevation = pcpng.offset.z + vertex.getPosition[2];
	// 色は頂点データのgetColorを使う
	const color = vertex.getColor;
	// 結果を返す
	return {
		coordinates: [lnglat.lng, lnglat.lat, elevation],
		color
	};
};
